export const PHOTO_CHALLENGE_CARD_MIN_QUANTITY = 10;
export const PHOTO_CHALLENGE_CARD_QUANTITY_STEP = 10;
export const PHOTO_CHALLENGE_CARD_MAX_QUANTITY = 500;
export const PHOTO_CHALLENGE_CARD_UNIT_AMOUNT_MINOR = 1_200;
export const PHOTO_CHALLENGE_CARD_SHIPPING_AMOUNT_MINOR = 4_900;
export const PHOTO_CHALLENGE_CARD_DELIVERY_ESTIMATE_BUSINESS_DAYS = 6;

export function isPhotoChallengeCardQuantity(value: unknown): value is number {
  return (
    typeof value === "number" &&
    Number.isInteger(value) &&
    value >= PHOTO_CHALLENGE_CARD_MIN_QUANTITY &&
    value <= PHOTO_CHALLENGE_CARD_MAX_QUANTITY &&
    value % PHOTO_CHALLENGE_CARD_QUANTITY_STEP === 0
  );
}

export function getPhotoChallengeCardPricing(quantity: number) {
  if (!isPhotoChallengeCardQuantity(quantity)) {
    throw new Error("Photo-challenge card quantity is invalid.");
  }
  const subtotalMinor = quantity * PHOTO_CHALLENGE_CARD_UNIT_AMOUNT_MINOR;
  return {
    quantity,
    unitAmountMinor: PHOTO_CHALLENGE_CARD_UNIT_AMOUNT_MINOR,
    subtotalMinor,
    shippingMinor: PHOTO_CHALLENGE_CARD_SHIPPING_AMOUNT_MINOR,
    totalMinor: subtotalMinor + PHOTO_CHALLENGE_CARD_SHIPPING_AMOUNT_MINOR,
  };
}
